import React from "react";
import { useTranslation } from "react-i18next";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import Button, { ButtonStyles } from "./Button.jsx";

export function BlockGetInTouchStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-get-in-touch": {
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "393px",

            "& > *": {
                display: "grid",
                gridGap: "40px",
                justifyContent: "center",
                alignItems: "center",
            },

            "& p": {
                wordBreak: "break-word",
                textAlign: "center",
                fontSize: "48px",
                fontWeight: "bold",
            },

            [MobileBreakpoint]: {
                "& p": {
                    fontSize: "18px",
                },
            },
        },

        ...ButtonStyles(params),
    };
}

export default function BlockGetInTouch(props) {
    const { t } = useTranslation();
    const { ProductType, GetInTouch } = props.variables;

    // [eCommerce] Hide block
    if (ProductType === "ecommerce" && !GetInTouch?.email) {
        return null;
    }

    const LI = useLoremIpsum();
    const { text, email, button } = GetInTouch || LI.getInTouch;

    const elProps = toElementProps(props, { className: ["block-get-in-touch"] });
    return (
        <div {...elProps}>
            <div>
                <p>{text || t("GetInTouchText")}</p>

                <div className="grid-center">
                    <Button
                        className={["without-gradient", "primary"]}
                        link={`mailto:${email || GetInTouch}`}
                        text={button || t("GetInTouch")}
                    />
                </div>
            </div>
        </div>
    );
}
